<template>
  <div>
    <b-table striped hover :items="invoiceList" :fields="invoiceFields" @row-clicked="rowClickHandler">
    </b-table>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

export default {
  props: {
    userId: {
      type: String
    },
    accountId: {
      type: String
    }
  },
  methods: {
    rowClickHandler (record, index) {
      this.$emit('clickOnInvoice', record.invoice_id)
    }
  },
  data () {
    return {
      invoiceList: [],
      invoiceFields: [
        { key: 'invoice_id', label: this.$i18n.t('Number invoices'), sortable: true, sortDirection: 'desc' },
        { key: 'date', label: this.$i18n.t('Date'), sortable: true, sortDirection: 'desc' },
        { key: 'binded_currency_sum', label: this.$i18n.t('Sum in currency'), sortable: true },
        { key: 'system_currency_sum', label: this.$i18n.t('Sum'), sortable: true }
      ]
    }
  },
  mounted () {
    axiosInstance.get(this.$store.getters.API_USERS_INVOICES + '?user_id=' + this.userId + '&account_id=' + this.accountId).then(response => {
      this.invoiceList = response.data
      for (var i in this.invoiceList) {
        let newDate = new Date(this.invoiceList[i].date * 1000)
        this.invoiceList[i].date = newDate.toLocaleString()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/Invoices.vue